import { HeaderNavigation } from "@faire/retailer-visitor-shared/components/Header/HeaderNavigation";
import { Column } from "@faire/web--source/slate/Layout";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React, { PropsWithChildren } from "react";
import styled, { css } from "styled-components";

interface IProps {
  onClose?: () => void;
  backgroundColor: string;
}

export const UpsellLayout: React.FC<PropsWithChildren<IProps>> = ({
  backgroundColor,
  children,
  onClose,
}) => {
  const { isMobile } = useViewport();
  return (
    <Container $backgroundColor={backgroundColor} align="center">
      <HeaderContainer $absoluteHeader={isMobile}>
        <HeaderNavigation
          onClose={onClose}
          inverse={isMobile}
          backgroundColor="transparent"
        />
      </HeaderContainer>
      {children}
    </Container>
  );
};

const Container = styled(Column)<{ $backgroundColor: string }>`
  background-color: ${({ $backgroundColor: backgroundColor }) =>
    backgroundColor};
  width: 100%;
  min-height: 100vh;
  position: relative;
`;

const HeaderContainer = styled.div<{ $absoluteHeader?: boolean }>`
  align-self: stretch;
  ${({ $absoluteHeader }) =>
    $absoluteHeader
      ? css`
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          z-index: 1;
        `
      : ""}
`;
